import ActionTypes from "./globalFilter.types";
import { DefaultDates } from "Consts";
import { isNullOrUndefined } from "utils";

const INITIAL_STATE = {
  clientId: null,
  clientInfo: {},
  GlobalActiveFilters: {},
  GlobalTopFilterObject: {},
  AssessmentTopFilterObject: {},
  GlobalTopFilterObjectValues: {},
  GlobalTopFilterObjectVersion: 0,
  DatePickerParams: DefaultDates,
  QuickTime: "",
  TopHistogramInterval: 60,
  IsGlobalFilterMode: true,
  LocalTopFilterObject: {},
  LocalDatePickerParams: DefaultDates,
  LocalTopFilterObjectVersion: 0,
  PerformanceCharts: [],
  PerformanceFilterObject: {},
  PerformanceSeriesObject: {},
  PerformanceTemplateObject: {},
  PerformanceDashboardObject: [],
  filterBlockHeight: 68,
  activeServerName: null,
  globalTable: {},
  navIsOpen: true,
  WisdomAdvisorContext: null,
  whatHappened: null,
  isAskingAdvisor: false,
  isTagFilterRefreshed: false,
  showAllOpenAlerts: false,
};

const globalFilterReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.SET_WISDOM_ADVISOR_CONTEXT: {
      return {
        ...state,
        WisdomAdvisorContext: action.payload,
      };
    }

    case ActionTypes.SET_FILTER_MODE: {
      const newState: any = {
        IsGlobalFilterMode: action.payload === "global",
      };

      if (!newState.isGlobalFilterMode) {
        newState.LocalTopFilterObject = { ...state.GlobalTopFilterObject };
        newState.LocalDatePickerParams = { ...state.DatePickerParams };
      }
      return {
        ...state,
        ...newState,
      };
    }

    case ActionTypes.SET_CURRENT_FILTER:
    case ActionTypes.SET_GLOBAL_STATE:
      if (action.payload.DatePickerParams) {
        action.payload.DatePickerParams.version = state.DatePickerParams.version + 1;
      }

      return {
        ...state,
        ...action.payload,
      };

    case ActionTypes.UPDATE_TOP_FILTER: {
      if (action.payload === null) {
        return {
          ...state,
          ...(state.IsGlobalFilterMode
            ? {
                GlobalTopFilterObject: {},
                GlobalTopFilterObjectVersion: 0,
              }
            : {
                LocalTopFilterObject: {},
                LocalTopFilterObjectVersion: 0,
              }),
        };
      }

      const selectedFilter: any = state.IsGlobalFilterMode
        ? state.GlobalTopFilterObject
        : state.LocalTopFilterObject;

      // Build clean payload WITHOUT mutation
      const filteredPayload = Object.entries(action.payload).reduce(
        (acc, [key, value]) => {
          try {
            if (JSON.stringify(selectedFilter[key]) !== JSON.stringify(value)) {
              acc[key] = value;
            }
          } catch (error) {
            console.error(error);
            acc[key] = value;
          }

          return acc;
        },
        {} as Record<string, any>
      );

      if (Object.keys(filteredPayload).length === 0) {
        return state;
      }

      const newTopFilters = {
        ...selectedFilter,
        ...filteredPayload,
      };

      return {
        ...state,
        ...(state.IsGlobalFilterMode
          ? {
              GlobalTopFilterObject: newTopFilters,
              GlobalTopFilterObjectVersion: (state.GlobalTopFilterObjectVersion || 0) + 1,
            }
          : {
              LocalTopFilterObject: newTopFilters,
              LocalTopFilterObjectVersion: (state.LocalTopFilterObjectVersion || 0) + 1,
            }),
      };
    }

    case ActionTypes.UPDATE_TOP_FILTER_VALUES: {
      if (action.payload === null) {
        const filterObj = {
          GlobalTopFilterObjectValues: {},
        };

        return {
          ...state,
          ...filterObj,
        };
      }

      const selectedFilter: any = state.GlobalTopFilterObjectValues;
      // check that we don't update the same value to prevent redundant renders

      Object.entries(action.payload).forEach(([key]) => {
        try {
          if (JSON.stringify(selectedFilter[key]) === JSON.stringify(action.payload[key])) {
            delete action.payload[key];
          }
        } catch (error) {
          console.error(error);
        }
      });

      if (Object.keys(action.payload).length === 0) {
        return state; // return prev state
      }

      // eslint-disable-next-line no-case-declarations
      const newTopFilters = {
        ...selectedFilter,
        ...action.payload,
      };

      const finalFilter = {
        GlobalTopFilterObjectValues: newTopFilters,
      };
      return {
        ...state,
        ...finalFilter,
      };
    }

    case ActionTypes.DROP_TOP_FILTER_HOSTS: {
      const selectedFilter: any = state.GlobalTopFilterObject;
      const selectedValues: any = state.GlobalTopFilterObjectValues;

      // eslint-disable-next-line no-case-declarations
      const newTopFilters = {
        ...selectedFilter,
      };

      delete newTopFilters?.hosts;

      const newTopValues = {
        ...selectedValues,
      };

      delete newTopValues?.hosts;

      const finalFilter = {
        GlobalTopFilterObject: newTopFilters,
        GlobalTopFilterObjectValues: newTopValues,
      };
      return {
        ...state,
        ...finalFilter,
      };
    }

    case ActionTypes.SET_ACTIVE_FILTERS: {
      if (action.payload === null) {
        return {
          ...state,
          GlobalActiveFilters: {},
        };
      }

      return {
        ...state,
        GlobalActiveFilters: action.payload,
      };
    }

    case ActionTypes.UPDATE_TOP_FILTER_DATES:
      return {
        ...state,
        DatePickerParams: { ...action.payload },
        GlobalTopFilterObjectVersion: (state.GlobalTopFilterObjectVersion || 0) + 1,
      };

    case ActionTypes.TOGGLE_SIDE_NAV:
      return {
        ...state,
        navIsOpen: !state.navIsOpen,
      };

    case ActionTypes.CLIENT_ID:
      return {
        ...state,
        clientId: action.payload.clientId,
      };

    case ActionTypes.CLIENT_INFO:
      return {
        ...state,
        clientInfo: action.payload.clientInfo,
      };

    case ActionTypes.CLEAR:
      return {
        ...INITIAL_STATE,
      };

    case ActionTypes.UPDATE_PERFORMANCE_CHARTS: {
      return {
        ...state,
        PerformanceCharts: action.payload,
      };
    }

    case ActionTypes.UPDATE_PERFORMANCE_FILTER: {
      if (action.payload[action.payload.key] === null) {
        return {
          ...state,
          PerformanceFilterObject: {},
        };
      }
      const selectedFilter: any = state.PerformanceFilterObject;

      Object.entries(action.payload).forEach(([key]) => {
        try {
          if (JSON.stringify(selectedFilter[key]) === JSON.stringify(action.payload[key])) {
            delete action.payload[key];
          }
        } catch (error) {
          console.error(error);
        }
      });

      if (Object.keys(action.payload).length === 0) {
        return state; // return prev state
      }

      // eslint-disable-next-line no-case-declarations
      const newTopFilters = {
        ...selectedFilter,
      };

      newTopFilters[action.payload.key] = {
        ...(!isNullOrUndefined(selectedFilter) && selectedFilter[action.payload.key]),
        ...action.payload[action.payload.key],
      };

      return {
        ...state,
        PerformanceFilterObject: newTopFilters,
      };
    }

    case ActionTypes.CLEAR_PERFORMANCE_FILTER: {
      if (action.payload === null || Object.keys(action.payload).length === 0) {
        return {
          ...state,
          PerformanceFilterObject: {},
        };
      }
      const selectedFilter: any = state.PerformanceFilterObject;

      Object.entries(action.payload).forEach(([key]) => {
        try {
          if (JSON.stringify(selectedFilter[key]) === JSON.stringify(action.payload[key])) {
            delete action.payload[key];
          }
        } catch (error) {
          console.error(error);
        }
      });

      // eslint-disable-next-line no-case-declarations
      const newTopFilters = {
        ...selectedFilter,
      };

      newTopFilters[action.payload.key] = null;

      return {
        ...state,
        PerformanceFilterObject: newTopFilters,
      };
    }

    case ActionTypes.UPDATE_PERFORMANCE_SERIES: {
      if (isNullOrUndefined(action.payload) || Object.keys(action.payload).length === 0) {
        return {
          ...state,
          PerformanceSeriesObject: {},
        };
      }

      const selectedFilter = state.PerformanceSeriesObject;

      // eslint-disable-next-line no-case-declarations
      const newTopFilters: any = {
        ...selectedFilter,
      };

      newTopFilters[action.payload.key] =
        action.payload[action.payload.key]?.length > 0 ? action.payload[action.payload.key] : [];

      return {
        ...state,
        PerformanceSeriesObject: newTopFilters,
      };
    }

    case ActionTypes.BULK_UPDATE_PERFORMANCE_SERIES: {
      if (isNullOrUndefined(action.payload) || Object.keys(action.payload).length === 0) {
        return {
          ...state,
          PerformanceSeriesObject: {},
        };
      }

      return {
        ...state,
        PerformanceSeriesObject: action.payload,
      };
    }

    case ActionTypes.UPDATE_PERFORMANCE_TEMPLATE: {
      if (isNullOrUndefined(action.payload)) {
        return {
          ...state,
          PerformanceTemplateObject: {},
        };
      }

      const selectedFilter = state.PerformanceTemplateObject;

      const newTopFilters = {
        ...selectedFilter,
      };
      //@ts-ignore
      newTopFilters[action.payload.key] =
        action.payload[action.payload.key]?.length > 0 ? action.payload[action.payload.key] : [];

      return {
        ...state,
        PerformanceTemplateObject: newTopFilters,
      };
    }

    case ActionTypes.UPDATE_PERFORMANCE_DASHBOARD: {
      if (isNullOrUndefined(action.payload)) {
        return {
          ...state,
          PerformanceDashboardObject: {},
        };
      }

      return {
        ...state,
        PerformanceDashboardObject: action.payload,
      };
    }

    case ActionTypes.UPDATE_FILTER_BLOCK_HEIGHT: {
      return {
        ...state,
        filterBlockHeight: action.payload,
      };
    }

    case ActionTypes.SET_THE_MOST_ACTIVE_SERVER: {
      return {
        ...state,
        activeServerName: action.payload,
      };
    }

    case ActionTypes.UPDATE_GLOBAL_TABLE: {
      return {
        ...state,
        globalTable: action.payload,
      };
    }

    case ActionTypes.UPDATE_WHAT_HAPPENED: {
      return {
        ...state,
        whatHappened: action.payload,
      };
    }

    case ActionTypes.SET_ASK_ADVISOR_FLAG: {
      return {
        ...state,
        isAskingAdvisor: action.payload,
      };
    }

    // used to refresh tag filter after assigment
    case ActionTypes.UPDATE_TAG_FILTER_REFRESH: {
      return {
        ...state,
        isTagFilterRefreshed: action.payload,
      };
    }

    case ActionTypes.SHOW_ALL_OPEN_ALERTS: {
      return {
        ...state,
        showAllOpenAlerts: action.payload,
      };
    }

    case ActionTypes.UPDATE_QUICK_TIME: {
      return {
        ...state,
        QuickTime: action.payload,
      };
    }

    default:
      return state;
  }
};

export default globalFilterReducer;
